/**
 * I fornitori sulla piattaforma nella console (atlante v2, cap. 446, 29/10/2026): lo stato (in attesa, approvato,
 * sospeso) e i bottoni per cambiarlo. Il resto della pagina «Fornitori» ha ancora i testi nel codice: si sposta qui
 * quando si tocca. Gemello di `en.ts`.
 */
export default {
  stato: {
    colonna: 'Sulla piattaforma',
    in_attesa: 'In attesa',
    approvato: 'Approvato',
    sospeso: 'Sospeso',
    dal: 'dal {{data}}',
    spiega_in_attesa: 'Le aziende non lo vedono ancora: niente merci, gare o accordi.',
  },
  azioni: {
    approva: 'Approva',
    sospendi: 'Sospendi',
    riattiva: 'Riattiva',
  },
  dialogo_sospendi: {
    titolo: 'Sospendi «{{fornitore}}»',
    testo: 'Le aziende non lo vedranno più per le merci, le gare e gli accordi nuovi. Gli sconti nei preventivi non cambiano.',
    motivo: 'Perché',
    motivo_aiuto: 'Resta nella storia del fornitore.',
    annulla: 'Annulla',
    conferma: 'Sospendi il fornitore',
  },
  esito: {
    approvato: '{{fornitore}} è approvato: da adesso le aziende lo vedono.',
    sospeso: '{{fornitore}} è sospeso.',
    errore: 'Lo stato non è cambiato: {{motivo}}',
  },
} as const;
